import Resource from '@/api/resources/Resource'

class SampleProcessingPortionService extends Resource {
    async findAllPortionEditableGrid(labId, casId, samId) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions`)
            .then(response => response.data)
    }

    async createBatch(labId, casId, samId, portions) {
        return this.axios.post(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions`, portions)
            .then(response => response.data)
    }

    async updateBatch(labId, casId, samId, portions) {
        return this.axios.put(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions`, portions)
            .then(response => response.data)
    }

    async deleteBatch(labId, casId, samId, portions) {
        const params = {
            entityIdentifiers: portions.map(portion => portion.id)
        }
        return this.axios.delete(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions`, { data: params })
            .then(response => response.data)
    }

    async verifyCassetteClosedBatch(labId, casId, samId, portions) {
        const params = {
            portionIds: portions.map(portion => portion.id)
        }
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/verifyCassetteClosedBatch`, { params })
            .then(response => response.data)
    }

    async verifyCassetteClosedByLabel(labId, casId, samId, portionLabel) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${portionLabel}/verifyCassetteClosed`)
            .then(response => response.data)
    }

    async searchPortionByLabel(laboratoryId, portionLabel) {
        return this.axios.get(`/sampleProcessing/laboratories/${laboratoryId}/portions/searchByLabel`, {
            params: {
                portionLabel: portionLabel
            }
        }).then(response => response.data)
    }
}

export default new SampleProcessingPortionService()
